import ReactGA from "react-ga";

/**
 * 头部导航点击跳转profile页面
 */
const GAHeaderClickToProfile = () => {
  ReactGA.event({
    category: "navigation",
    action: "navigation_profile_click",
  });
};

/**
 * 头部导航点击跳转history页面
 */
const GAHeaderClickToHistory = () => {
  ReactGA.event({
    category: "navigation",
    action: "navigation_history_click",
  });
};

/**
 * 头部导航点击跳转setting页面
 */
const GAHeaderClickToSetting = label => {
  ReactGA.event({
    category: "navigation",
    action: "navigation_setting_click",
    label,
  });
};

/**
 * 头部导航点击跳转购买页面
 */
const GAHeaderClickToUpgrade = () => {
  ReactGA.event({
    category: "navigation",
    action: "navigation_upgrade_click",
  });
};

/**
 * 头部导航点击退出登录
 */
const GAHeaderClickLogout = () => {
  ReactGA.event({
    category: "navigation",
    action: "navigation_logout_click",
  });
};

export { GAHeaderClickToProfile, GAHeaderClickToHistory, GAHeaderClickToSetting, GAHeaderClickToUpgrade, GAHeaderClickLogout };
